import {createSlice} from "@reduxjs/toolkit"
import { getCountry,getCurrency,getTimeZone,getGenralSetting, saveGenralSetting } from "../../actions/configuration-setting/GeneralSettingAction"

const initialState={
    //get country 
    loading: false,
    countryList: null,
    error:null,
    success: false, 
    // get currency
    loading1: false,
    currencyList: null,
    error1:null,
    success1: false,
    //get timeZone 
    loading2: false,
    timeZoneList: null,
    error2:null,
    success2: false, 
    //get general setting
    loading3: false,
    getGnlSetting: null,
    error3:null,
    success3: false,
    //save general setting
    loading4: false,
    saveGnlSetting: null,
    error4:null,
    success4: false,

}

const generalSettingSlice =  createSlice({
    name: "general-setting",
    initialState,
    extraReducers: (builder) =>{
        builder
        //get country
        .addCase(getCountry.pending, (state) => {
            state.loading =true;
            state.error = null;
            state.success = false;
        })
        .addCase(getCountry.fulfilled, (state, {payload}) => {
            state.loading =false;
            state.countryList = payload;
            state.success = true;
            state.error = null;
        })
        .addCase(getCountry.rejected,(state, {payload}) => {
            state.loading =false;
            state.error = payload;
            state.success = false;
        })
        // get currency 
        .addCase(getCurrency.pending, (state) => {
            state.loading1 =true;
            state.error1 = null;
            state.success1 = false;
        })
        .addCase(getCurrency.fulfilled, (state, {payload}) => {
            state.loading1 =false;
            state.currencyList = payload;
            state.success1 = true;
            state.error1 = null;
        })
        .addCase(getCurrency.rejected,(state, {payload}) => {
            state.loading1 =false;
            state.error1 = payload;
            state.success1 = false;
        })
        // get time zone
        .addCase(getTimeZone.pending, (state) => {
            state.loading2 =true;
            state.error2 = null;
            state.success2 = false;
        })
        .addCase(getTimeZone.fulfilled, (state, {payload}) => {
            state.loading2 =false;
            state.timeZoneList = payload;
            state.success2 = true;
            state.error2 = null;
        })
        .addCase(getTimeZone.rejected,(state, {payload}) => {
            state.loading2 =false;
            state.error2 = payload;
            state.success2 = false;
        })
        //get general configuration setting
        .addCase(getGenralSetting.pending, (state) => {
            state.loading3 =true;
            state.error3 = null;
            state.success3 = false;
        })
        .addCase(getGenralSetting.fulfilled, (state, {payload}) => {
            state.loading3 =false;
            state.getGnlSetting = payload;
            state.success3 = true;
            state.error3 = null;
        })
        .addCase(getGenralSetting.rejected,(state, {payload}) => {
            state.loading3 =false;
            state.error3 = payload;
            state.success3 = false;
        })
         //save general configuration setting
         .addCase(saveGenralSetting.pending, (state) => {
            state.loading4 =true;
            state.error4 = null;
            state.success4 = false;
        })
        .addCase(saveGenralSetting.fulfilled, (state, {payload}) => {
            state.loading4 =false;
            state.saveGnlSetting = payload;
            state.success4 = true;
            state.error4 = null;
        })
        .addCase(saveGenralSetting.rejected,(state, {payload}) => {
            state.loading4 =false;
            state.error4 = payload;
            state.success4 = false;
        })
    }
})

export default generalSettingSlice.reducer;